export function ProjectsPage() {
  return (
    <section className="simple-page">
      <h1>Projects</h1>
      <p>Placeholder content: hardware and software projects will be showcased here.</p>
    </section>
  );
}
